import { BillingPeriod } from '@stigg-types/apiTypes';
import { formatPrice } from '../../../../utils/priceFormatUtils';
import { DEFAULT_CURRENCY } from '../../../currency/currencyUtils';

export function formatTrialSpendLimit(limit: number) {
  return formatPrice({ amount: limit, currency: DEFAULT_CURRENCY }, BillingPeriod.Monthly);
}
